import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import badgeGroupRecipe from './index.recipe'
import {Box, useRecipe} from '@chakra-ui/react3'

/* Components */
import Badge from './badge'

/* Hooks */
import {useBadges} from '../../hooks/use-badges'

const BadgeGroup = ({
    containerProps,
    product,
    promotions,
    max,
    maxCharsPerBadge = 18,
    maxSummedChars
}) => {
    const rawBadges = useBadges(product, promotions)
    const recipe = useRecipe({recipe: badgeGroupRecipe})
    const groupStyles = useMemo(() => recipe({}), [recipe])

    const badges = useMemo(() => {
        const badges = []
        let characters = 0
        for (const badge of rawBadges) {
            /* honor max limit */
            if (max != null && badges.length >= max) {
                break
            }

            // skip long badges
            if (badge.text.length > maxCharsPerBadge) {
                continue
            }

            // remove duplicate badges (same text)
            if (badges.some((obj) => obj.text === badge.text)) {
                break
            }

            // stop once we reach the character limit
            if (maxSummedChars && characters + badge.text.length > maxSummedChars) {
                break
            }

            // add the badge
            badges.push(badge)
            characters += badge.text.length
        }
        return badges
    }, [rawBadges, max, maxCharsPerBadge, maxSummedChars])

    /* Return if badges array is empty */
    if (badges.length <= 0) {
        return null
    }

    return (
        <Box {...containerProps} css={[groupStyles, containerProps?.css]}>
            {badges.map(({text, variant, colorWorld}, index) => {
                return <Badge key={index} text={text} variant={variant} colorWorld={colorWorld} />
            })}
        </Box>
    )
}

BadgeGroup.propTypes = {
    product: PropTypes.object.isRequired,
    containerProps: PropTypes.object,
    promotions: PropTypes.array,
    /* Limits visible badges to passed number */
    max: PropTypes.number,
    /* Maximum badge text length */
    maxCharsPerBadge: PropTypes.number,
    /* Maximum summed badges texts length */
    maxSummedChars: PropTypes.number
}

export default BadgeGroup
